import { Component } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService, SortingService, PriceCalculationService, CommonDataService, ProgressBarService, AlternateOptionsService
} from '../expert-service-call.index';
import { type } from 'os';
import * as _ from 'lodash';
@Component({
	selector: 'expert-color-options',
	templateUrl: './expert-color.template.html',
	styleUrls: ['./expert-color-component.css'],
})
export class ExpertColorOptions {
	public colorOptions = [];
	private colorKeyValues: String[] = [];
	public expColor: Data[] = [];
	public selected: Data[] = [];
	public retained = [];
	public expertColorOptions: any;
	public subscription: Subscription;
	public templastColor:any;
	constructor(private dataLoaderService: DataLoaderService, private resetService: ResetService,
		private priceCalculationService: PriceCalculationService, private sortingService: SortingService, private commonDataService: CommonDataService, private progressService: ProgressBarService, private alternateOptionService:AlternateOptionsService) {
		this.colorOptions = this.dataLoaderService.data.color;
		this.colorOptions.forEach(element => {
			if(element.selected == true){
				this.alternateOptionService.intialExpertColor = element
			}
		});
	}
	ngOnInit() {
		//Retention Service
		
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalColor") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					if(!this.dataLoaderService.flagDictionary.undoActivatedForColor){
						this.dataLoaderService.previousColorExp = selectedOption.data[0].code;
					}
				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForColor){
						this.dataLoaderService.previousColorExp = [];
					}
				}
				this.progressService.progressBarValidation();
				
			}
		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertColor") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					this.dataLoaderService.previousColorExp = selectedOption.data[0].code;
				} else {
					this.selected = [];
					this.dataLoaderService.previousColorExp = [];
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForColor= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//this.dataLoaderService.previousExpertColor = selectedOption.data[0];
		//On load	
		let colour;
		this.colorOptions.forEach(element => {
			if (element.selected === true) {
				colour = element;
				this.dataLoaderService.previousExpertColor = colour;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [colour] });
				this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [colour] });
			}
		});
		//Reset
		this.subscription = this.resetService.notifyObservable$.subscribe(() => {
			this.selected = this.resetService.expColor;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: this.resetService.expColor });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: this.resetService.expColor });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}

	ngAfterContentChecked() {
		this.colorKeyValues = [];
		for (let index = 0; index < this.colorOptions.length; index++) {
			if (this.colorOptions[index].selected === false) {
				this.colorKeyValues.push(((this.colorOptions[index].code + " - " + this.colorOptions[index].description)));
			}
		}
		for (let j = 0; j < this.colorKeyValues.length; j++) {
			if (this.selected != undefined) {
				for (let i = 0; i < this.selected.length; i++) {
					let item = this.colorKeyValues[j].substring(0, this.colorKeyValues[j].indexOf(' - '));
					let temp = this.selected[i] + "";
					if (item === temp) {
						this.colorKeyValues.splice(Number(j), 1);
					}
				}
			}
		}

	}

	clearOptions() {
		this.expertColorOptions = null;
	}
	
	// adds selected color	
	onColorOptionClick(item) {
		// let addedColor:any=[];

		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForColor= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end

		// if (this.dataLoaderService.previousExpertColor.length>0) {
		// 	this.dataLoaderService.expertRemovedCodes.push(this.dataLoaderService.previousExpertColor[0]);
		// }
		// this.dataLoaderService.previousExpertColor = [];
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let colorCode;
		colorCode = item.substr(0, 3);
		this.selected = colorCode;
		// for added codes 
		// addedColor.push(colorCode);

		// addedColor=_.uniqBy(addedColor, function (o) {
		// 	return o;
		// });
		// this.dataLoaderService.expAdd.push(colorCode);
		
		this.dataLoaderService.flagDictionary.expertValidateFlag = true;
		this.dataLoaderService.flagDictionary.expertvalidated = false;
		for (let i in this.colorOptions) {
			if (this.colorOptions[i].code === colorCode) {
				this.expColor = this.colorOptions[i];
				// this.dataLoaderService.previousExpertColor[0] = this.colorOptions[i];
				this.colorOptions[i].selected = true;

			}
			else {
				this.colorOptions[i].selected = false;
			}
			
		}
		// For expert added codes
		// for (let i in this.colorOptions) {
		// 	for (let j in this.dataLoaderService.expAdd){
		// 		if (item != this.dataLoaderService.previousColorExp 
		// 			&& this.colorOptions[i].code == this.dataLoaderService.expAdd[j] 
		// 			&& !this.colorOptions[i].selected) {
		// 				this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 		if(this.dataLoaderService.expAdd[j]==this.dataLoaderService.previousColorExp){
		// 			this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 	}
		// }
		// if(this.dataLoaderService.previousColorExp != undefined || this.dataLoaderService.previousColorExp.length>0){
		// 	if(this.expColor["code"]==this.dataLoaderService.previousColorExp){
		// 		 this.expColor=[];
		// 	}
		// }
		
		this.sortingService.sortCodes(this.colorOptions, true)
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.expColor] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.expColor] });
		this.priceCalculationService.expertModePriceCalculation();
		this.progressService.progressBarValidation();
		
	}

	//removes selected color
	deleteSelExpColor(item) {
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let colorCode;
		colorCode = item.substr(0, 3);
		this.selected = [];
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertColor", data: this.selected });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalColor", data: this.selected });
		let selcFacForRem = [];
		for (let k in this.colorOptions) {
			if (this.colorOptions[k].selected) {
				selcFacForRem.push(this.colorOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertColor", data: [selcFacForRem] });
		for (let i in this.colorOptions) {
			if (this.colorOptions[i].code === colorCode) {
				this.dataLoaderService.expertRemovedCodes.push(this.colorOptions[i]);
				this.colorOptions[i].selected = false;
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				//this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		this.priceCalculationService.expertModePriceCalculation();
		this.progressService.progressBarValidation();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-color/expert-color.component.ts